//
//
//
//
//
//
//
//
//
//
//
//

import SfIcon from '../../../atoms/SfIcon/SfIcon.vue';


export default {
    name: "MoominHeaderSearchSuggestionsRow",
    props: {
        suggestion: {
            type: String,
        },
        noResults: {
            type: Boolean,
            default: false
        },
        noResultsText: {
            type: String
        }
    },
    components: { SfIcon }
};
